import { render } from "./edit.vue?vue&type=template&id=365c8288&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=365c8288&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365c8288"],['__file',"src/views/food/dish/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "365c8288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('365c8288', __exports__)) {
    console.log('reload')
    api.reload('365c8288', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=365c8288&scoped=true", () => {
    console.log('re-render')
    api.rerender('365c8288', render)
  })

}


export default __exports__